import React, { useMemo } from "react";
import { useStore } from "../../../stores/store";
import ToolbarButton from "../../Toolbar/ToolbarButton";

//@ts-expect-error
import zoomAllIcon from "./zoomAll.png";
//@ts-expect-error
import removeAllIcon from "./removeAll.png";
//@ts-expect-error
import bufferIcon from "./buffer.png";
//@ts-expect-error
import exportExcelIcon from "./exportExcel.png";

import { DraggableKeys } from "../../../interfaces/config";
import Draggable from "react-draggable";

export type TaxParcel = {
  parcelNumber: string;
  township: string;
};

export const ResultsToolbar = (props) => {
  const {
    setDetailsSelection,
    zoomToResults,
    results,
    activateTool,
    setResults,
    setSelectedResults,
    highlightLayer,
    bufferLayer,
    config,
  } = useStore();

  const toolbarButtons = useMemo(() => {
    return [
      {
        label: "Zoom All",
        value: "zoomAll",
        icon: zoomAllIcon,
        onClick: () => {
          zoomToResults();
        },
      },
      {
        label: "Remove All",
        value: "removeAll",
        icon: removeAllIcon,
        onClick: () => {
          setDetailsSelection(null);
          setSelectedResults([]);
          setResults([]);
          highlightLayer?.removeAll();
          bufferLayer?.removeAll();
        },
      },
      {
        hidden: !config?.toolbarOptions?.visibleTools?.buffer,
        label: "Buffer",
        value: "buffer",
        icon: bufferIcon,
        onClick: () => {
          activateTool(DraggableKeys.BUFFER_DRAGGABLE);
        },
      },
      {
        label: "Export CSV",
        value: "exportCSV",
        icon: exportExcelIcon,
        onClick: () => {
          const csvHeaders = Object.keys(results[0].attributes).join(",");
          const csv = results
            .map((r) => {
              const escaped = Object.values(r.attributes).map((v) => {
                if (typeof v === "string") {
                  return v
                    .replace(/,/g, " ")
                    .replace(/\s+/g, " ")
                    .replace(/"/g, '""');
                }
                return v;
              });
              return escaped.join(",");
            })
            .join("\n");
          const blob = new Blob([csvHeaders + "\n" + csv], {
            type: "text/csv",
          });
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.setAttribute("href", url);
          a.setAttribute("download", "results.csv");
          a.click();
        },
      },
    ];
  }, [config]);

  return (
    <div
      style={{
        backgroundImage: props.options.toolbarBackgroundImage
          ? props.options.toolbarBackgroundImage
          : "linear-gradient(to bottom, #d9af66, #a58752)",
      }}
      className="h-8 overflow-visible shadow-sm flex justify-between"
    >
      <div>
        {toolbarButtons.map((button, i) => {
          if (button.hidden) {
            return;
          }
          return (
            <ToolbarButton
              id={"results" + i}
              key={i}
              active={false}
              disabled={results.length === 0}
              label={button.label}
              onClick={button.onClick}
              icon={button.icon}
              iconSize="sm"
              highlightColor={props.options.toolbarButtonHighlightColor}
              textColor={props.options.toolbarButtonTextColor}
            />
          );
        })}
      </div>
    </div>
  );
};
